import { render, staticRenderFns } from "./input-precision.vue?vue&type=template&id=523c4a34&scoped=true&"
import script from "./input-precision.vue?vue&type=script&lang=js&"
export * from "./input-precision.vue?vue&type=script&lang=js&"
import style0 from "./input-precision.vue?vue&type=style&index=0&id=523c4a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c4a34",
  null
  
)

export default component.exports